import * as yup from "yup";

const keywordMetadataSchema = yup.object({
  keyword: yup.string().required(),
  effectiveFrom: yup.string().required(), // "YYYY-MM" format
  changeType: yup.string().oneOf(["added", "removed"]).required(),
});

const searchConfigurationSchema = yup
  .object({
    keywords: yup.array(yup.string().required()).required(),
    keywordsMetadata: yup.array(keywordMetadataSchema).optional(),
    relatedKeywords: yup.array(yup.string().required()).optional(),
  })
  .required();

export default searchConfigurationSchema;
